class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverCloseTimer = null;
    this.openOnHover = this.openOnHover.bind(this);
    this.closeOnLeave = this.closeOnLeave.bind(this);
    this.onShopLandingClick = this.onShopLandingClick.bind(this);

    if (this.hasAttribute('data-hover-open')) {
      this.addEventListener('pointerenter', this.openOnHover);
      this.addEventListener('pointerleave', this.closeOnLeave);
      this.addEventListener('click', this.onShopLandingClick, true);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('pointerenter', this.openOnHover);
    this.removeEventListener('pointerleave', this.closeOnLeave);
    this.removeEventListener('click', this.onShopLandingClick, true);
    this.clearHoverCloseTimer();
  }

  hoverEnabled() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  clearHoverCloseTimer() {
    if (this.hoverCloseTimer) {
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = null;
    }
  }

  openOnHover(event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    if (!this.hoverEnabled()) return;
    this.clearHoverCloseTimer();
    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  onShopLandingClick(event) {
    const landingUrl = this.getAttribute('data-shop-landing-url');
    if (!landingUrl) return;
    if (event.target.closest('.header-shop-aisles__bar')) return;

    const summary = this.mainDetailsToggle?.querySelector('summary');
    if (!summary || !summary.contains(event.target)) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.assign(landingUrl);
  }

  closeOnLeave() {
    if (!this.hoverEnabled()) return;
    this.clearHoverCloseTimer();
    this.hoverCloseTimer = setTimeout(() => {
      if (this.matches(':hover')) return;
      if (this.contains(document.activeElement)) return;
      this.close();
    }, 250);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
